export function AppIconSettingsScreen(): never {
  throw new Error('Not supported on web')
}
